import { createContext, useContext } from "react";

export const ArchiveVisibilityContext = createContext<boolean>(false);

export function useArchiveVisibility() {
    return useContext(ArchiveVisibilityContext);
}
